<div class="flex flex-1 mt-2 mb-3" *ngIf="this.context.writePermission">
    <div class="p-input-icon-left flex-1" id="searchBarContainer">
        <i class="ml-1 far fa-magnifying-glass"></i>
        <input type="text" class="w-12" pInputText id="searchBar" (keyup)="onSearchBarKeyUp($event.target)" />
    </div>

    <span class="p-buttonGroup">
        <button pButton class="ml-1 whiteButton whiteButtonLast exportButton" (click)="onExportToExcel()"
            icon="far fa-file-excel"></button>
    </span>
</div>

<div class="flex-1 relative">
    <div class="container overflow-y-auto h-full w-full">
        <div *ngIf="filteredFeedbacks.length==0" i18n="@@event.feedback.overview.no-feedback" class="emptyMessage">
            There is no feedback for the selected date.
        </div>

        <div class="flex mb-3 feedbackContainer" *ngIf="filteredFeedbacks.length>0">
            <div class="flex justify-content-center align-items-center positiveFeedback" *ngIf="statistics[feedbackType.Positive] > 0">
                <i class="fa-light fa-thumbs-up font-bold m-1 text-xl feedback-color-success"></i>
                <span class="font-bold ml-1">{{statistics[feedbackType.Positive]}}</span>
            </div>
            <div class="ml-2 flex justify-content-center align-items-center negativeFeedback"
                *ngIf="statistics[feedbackType.Negative] > 0">
                <i class="fa-light fa-thumbs-down font-semibold m-1 text-xl feedback-color-danger"></i>
                <span class="font-bold ml-1">{{statistics[feedbackType.Negative]}}</span>
            </div>
            <div class="ml-2 flex justify-content-center align-items-center maybeFeedback" *ngIf="statistics[feedbackType.Maybe] > 0">
                <i class="fa-light fa-question font-semibold m-1 text-xl feedback-color-warning"></i>
                <span class="font-bold ml-1">{{statistics[feedbackType.Maybe]}}</span>
            </div>

            <div class="ml-2 flex justify-content-center align-items-center pendingFeedback"
                *ngIf="statistics[feedbackType.Pending] > 0">
                <i class="fa-light fa-reply-clock font-semibold m-1 text-xl text-blue-600"></i>
                <div class="font-bold ml-1">{{statistics[feedbackType.Pending]}}</div>
            </div>
        </div>

        <div *ngFor="let feedback of filteredFeedbacks">
            <div class="flex mt-2 align-items-center">
                <div class="flex flex-column flex-1 p-3 md:p-4 w-full eventSignupAttendeeWrapper">
                    <div class="flex flex-column justify-content-between md:flex-row">
                        <div class="flex align-items-center">
                            <div class="flex align-items-center mr-2 md:mr-2 profileImage">
                                <img *ngIf="feedback.client"
                                    [src]="apiURL + '/file-api/userprofile/image/' + feedback.client.id + '?thumbnail=true&access_token=' + coreLibService.getJWTToken()"
                                    class="shadow-none w-full"
                                    style="border-radius: 6px; object-fit: cover;max-width:5rem;" />
                            </div>
                            <div class="flex flex-column feedback" style="word-break: break-all;">
                                <div class="ml-2 md:ml-4" *ngIf="!feedback.client?.id"></div>
                                <div class="ml-2 mb-2 feedbackDate">
                                    {{ feedback.creationDate | date:'medium' }}
                                </div>

                                <div class="ml-2 font-semibold feedbackName">
                                    {{feedback.client.firstname}}
                                    {{feedback.client.name}}
                                </div>

                                <div class="ml-2 mt-2 flex align-items-center feedbackEmail" *ngIf="context.event.canWrite">
                                    <i class="far fa-envelope mr-1"></i> :
                                    <a (click)="onMailTargetClient(feedback.client.email)"
                                        class="ml-1 cursor-pointer font-semibold">
                                        {{feedback.client.email}}
                                    </a>
                                </div>
                                <div class="ml-2 mt-2 flex align-items-center feedbackPhone"
                                    *ngIf="feedback.client.phoneMobile?.length && context.event.canWrite">
                                    <i class="far fa-phone mr-1"></i> :
                                    <a (click)="onPhoneTargetClient(feedback.client.phoneMobile)"
                                        class="ml-1 cursor-pointer font-semibold">
                                        {{feedback.client.phoneMobile}}
                                    </a>
                                </div>
                                <div class="ml-2 mt-2 flex align-items-center feedbackChat"
                                    *ngIf="feedback.client.id && coreLibService.isNativeApp()">
                                    <i class="far fa-message-lines mr-1"></i> :
                                    <a (click)="onOpenChatWithUser(feedback.client.id)"
                                        class="ml-1 cursor-pointer font-semibold"
                                        i18n="@@event-sign-ups-overview.directchat">
                                        Direct chat
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-column align-items-center	mt-2">
                        <div class="mr-2 feedbackComment" *ngIf="feedback.comment">
                            {{feedback.comment}}
                        </div>
                        <ng-container *ngIf="feedback.status === feedbackType.Positive">
                            <i class="fa-light fa-thumbs-up font-bold m-2 text-2xl feedback-color-success positiveFeedback"></i>
                        </ng-container>
                        <ng-container *ngIf="feedback.status === feedbackType.Negative">
                            <i class="fa-light fa-thumbs-down font-semibold m-2 text-2xl feedback-color-danger negativeFeedback"></i>
                        </ng-container>
                        <ng-container *ngIf="feedback.status === feedbackType.Maybe">
                            <i class="fa-light fa-question font-semibold m-2 text-2xl feedback-color-warning maybeFeedback"></i>
                        </ng-container>

                        <ng-container *ngIf="feedback.status === feedbackType.Pending">
                            <i class="fa-light fa-reply-clock font-semibold m-2 text-2xl text-blue-600 pendingFeedback"></i>
                        </ng-container>

                    </div>

                </div>
            </div>
        </div>
    </div>
</div>